import { managerGridHeight } from '~/utils';

const styles = {
  container: {
    display: 'flex',
    backgroundColor: '#F9F9F9',
    height: managerGridHeight,
    padding: 10,
  },
  icon: {
    marginRight: 10,
  },
  button: {
    color: '#FFF',
    margin: 5,
  },
  terrainImg: {
    margin: 10,
  },
  tabContainer: {
    borderRadius: 5,
    borderTopLeftRadius: 0,
    backgroundColor: 'white',
    padding: 10,
  },
  field: {
    border: '1px solid #CDCDCD',
    borderRadius: 5,
    height: 40,
  },
  fieldSelect: {
    borderRadius: 5,
    height: 40,
    color: '#647886',
    width: '100%',
    borderWidth: 0,
  },
  fieldError: {
    border: '1px solid red !important',
  },
  labelTypeSelector: {
    color: '#647886',
    fontFamily: 'Barlow Condensed',
    fontWeight: 600,
    fontSize: 18,
    textTransform: 'uppercase',
    marginRight: 10,
  },
  filterSelector: {
    bottom: '8px',
    marginTop: '8px',

  },
  classObservation: {
    flex: 1,
    minWidth: 290,
    marginRight: 10,
  },
  formLabel: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginBottom: 5,
  },
  errorMessage: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 12,
    textAlign: 'center',
    color: '#EC3337',
    marginLeft: 10,
  },
  table: {
    height: 'calc(100vh - 52px - 52px - 360px)',
    width: 'calc(100vw - 200px)',
  },
};

export default styles;
